import { makeAutoObservable } from 'mobx';

export class Auth {
	id;
	usage;
	name;
	roles;
	token;
	collectionName;
	collectionId;
	parentId;
	type;
	profiles;
	profile;

	store;

	constructor(store, auth) {
		makeAutoObservable(this);
		this.store = store;

		this.id = auth?.id;
		this.usage = auth?.usage;
		this.name = auth?.name;
		this.roles = auth?.roles;
		this.token = auth?.token;
		this.collectionName = auth?.collectionName;
		this.collectionId = auth?.collectionId;
		this.parentId = auth?.parentId;
		this.type = auth?.type;
		this.profiles = auth?.profiles;
		this.profile = auth?.profile;
	}

	setProfile(data) {
		this.profile = data;
	}

	setProfiles(data) {
		this.profiles = data;
	}

	toJSON() {
		return {
			id: this.id,
			usage: this.usage,
			name: this.name,
			roles: this.roles,
			token: this.token,
			collectionName: this.collectionName,
			collectionId: this.collectionId,
			parentId: this.parentId,
			type: this.type,
			profiles: this.profiles,
			profile: this.profile,
			// Note: excluding 'store' to avoid circular reference
		};
	}
}
